import { render, staticRenderFns } from "./AddOptions.vue?vue&type=template&id=89501a56&scoped=true&"
import script from "./AddOptions.vue?vue&type=script&lang=js&"
export * from "./AddOptions.vue?vue&type=script&lang=js&"
import style0 from "./AddOptions.vue?vue&type=style&index=0&id=89501a56&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89501a56",
  null
  
)

export default component.exports